var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCrossBlackRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 0c4.408 0 8 3.592 8 8 0 4.408-3.592 8-8 8-4.408 0-8-3.592-8-8 0-4.408 3.592-8 8-8zM5.341 4.506c-.234-.162-.557-.139-.765.07-.235.234-.235.614 0 .848L7.15 8l-2.575 2.576-.07.083c-.162.234-.139.557.07.765.234.235.614.235.848 0L8 8.85l2.576 2.575.083.07c.234.162.557.139.765-.07.235-.234.235-.614 0-.848L8.85 8l2.575-2.576.07-.083c.162-.234.139-.557-.07-.765-.234-.235-.614-.235-.848 0L8 7.15 5.424 4.576l-.083-.07z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCrossBlackRound);
export default __webpack_public_path__ + "static/media/ic_cross_black_round.064ceb564c2cff0a70fcce606fda8781.svg";
export { ForwardRef as ReactComponent };